import { z } from 'zod';

export const BcmInitialResponseLibrarySchema = z.object({
    id: z.string().optional(),
    step: z.string().min(1, "Step is required"),
    action: z.string().min(1, "Action is required"),
    responsible: z.string().nullish(),
    details: z.string().nullish(),
    timeframe: z.string().nullish(),
    include: z.boolean().default(true).nullish(),

    // Compatibility fields
    title: z.string().optional(),
    description: z.string().optional(),
    steps: z.string().optional(),
    createdAt: z.union([z.date(), z.string()]).optional(),
    updatedAt: z.union([z.date(), z.string()]).optional(),
    customFields: z.record(z.unknown()).optional(),
});
export const CreateBcmInitialResponseLibrarySchema = BcmInitialResponseLibrarySchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateBcmInitialResponseLibrarySchema = BcmInitialResponseLibrarySchema.partial();
